import type { UserFilters } from "./filters";

/** TanStack Query keys for admin-related queries. */
export const adminKeys = {
  usersRoot: ["admin", "users"] as const,
  users: (filters: UserFilters) => ["admin", "users", filters] as const,
  userDetailRoot: ["admin", "user-detail"] as const,
  userDetail: (userId: string) => ["admin", "user-detail", userId] as const,
  userUsage: (userId: string, fromISO: string, toISO: string) =>
    ["admin", "user-usage", userId, fromISO, toISO] as const,
  statsOverview: ["admin", "stats", "overview"] as const,
  globalUsage: (fromISO: string, toISO: string) =>
    ["admin", "stats", "usage", fromISO, toISO] as const,
};
